var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.src && !_vm.failed
    ? _c("img", {
        staticClass: "kvm-logo flex-grow-0",
        attrs: {
          src: _vm.src,
          width: _vm.size,
          height: _vm.size,
          alt: "",
          "aria-hidden": "true"
        },
        on: {
          error: function error($event) {
            _vm.failed = true
          }
        }
      })
    : _c(
        "v-icon",
        {
          staticClass: "kvm-logo kvm-logo--icon flex-grow-0",
          attrs: {
            size: _vm.size,
            "aria-hidden": "true"
          }
        },
        [_vm._v(_vm._s(_vm.icon))]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }